<template>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="selectFluxer">
      <md-dialog-title v-if="!isEspontaneo">Pedir feedback a un compañero</md-dialog-title>
      <md-dialog-title v-if="isEspontaneo">Dar feedback espontaneo</md-dialog-title>

      <md-dialog-content>
        <autocomplete v-model="fluxerSelected" :label="'Busca al fluxer aqui'" :array="allFluxers" :debounce="1000"></autocomplete>
        <span v-show="error" class="md-error">El fluxer seleccionado es incorrecto</span>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click.native="onOkSelectFluxer('cancel', 'selectFluxer')">Cancelar</md-button>
        <md-button class="md-primary" @click.native="onOkSelectFluxer('ok', 'selectFluxer')">aceptar</md-button>
      </md-dialog-actions>

      <md-snackbar @close="clearInput()" :md-position="'bottom center'" ref="toastFluxer" :md-duration="4000">
        <span v-if="!isEspontaneo">El feedback se pidio correctamente a: {{fluxerSelected}} </span>
        <span v-if="isEspontaneo">El feedback espontaneo a: {{fluxerSelected}} se creo correctamente </span>
      </md-snackbar>
    </md-dialog>
</template>

<script>
import FeedbacksService from '../services/feedbacks'
import NotificationsService from '../services/notifications'
import FluxerService from '../services/fluxer'
import _ from 'lodash'
import Router from '../router'
import Autocomplete from './Autocomplete'

export default {
  name: 'feedback-companion',
  props: ['currentFluxer', 'isEspontaneo'],
  components: {
    'autocomplete': Autocomplete
  },
  data () {
    return {
      fluxerSelected: null,
      error: false
    }
  },
  firebase: function () {
    return {
      // debe retornar los fluxers que no tienen feedbacks abiertos anteriores
      allFluxers: FluxerService.getAll()
    }
  },
  methods: {
    open () {
      this.$refs['selectFluxer'].open()
      this.clearInput()
    },
    onOkSelectFluxer (type, ref) {
      if (type === 'ok') {
        let fluxerSelected = this.fluxerSelected
        let fluxerSelect = _.find(this.allFluxers, function (o) { return o.displayName === fluxerSelected })

        if (!fluxerSelect) {
          this.error = true
        } else {
          this.error = false
          if (!this.isEspontaneo) {
            let currentFluxer = this.currentFluxer
            FeedbacksService.create(this.currentFluxer, fluxerSelect.email, 'companion', this.isEspontaneo).then((feedId) => {
              NotificationsService.solicitarFeedback(feedId, fluxerSelect.email, currentFluxer)
              this.$refs.toastFluxer.open()
              this.$refs[ref].close()
            })
          } else {
            FeedbacksService.create(fluxerSelect.email, this.currentFluxer.email, 'espontaneo', this.isEspontaneo).then((feedId) => {
              Router.push('feedback/' + feedId)
              this.$refs[ref].close()
            })
          }
        }
        this.$router.replace('proceso')
      } else {
        this.error = false
        this.clearInput()
        this.$refs[ref].close()
      }
    },
    clearInput () {
      this.fluxerSelected = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-error {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// FeedbackCompanion.vue?69104ddc